import {
  AiModelState,
  getPrefixName,
  hideRadioClassName,
  Prefix,
  stores2storeScopes,
} from './share';
import { Radio } from 'antd';
import { useCallback, useMemo } from 'react';
import { updateWholesale } from 'views/BootGuide/service';
import ModalMode from './ModalMode';
import { useTranslate } from '@tolgee/react';
import useSmartField from 'hooks/useSmartField';

type FV = BootGuide.AiModel.FormValues.Wholesale;

export function useLabel() {
  const { t } = useTranslate();

  return useMemo(() => {
    return {
      noSupport: t('本店不支持批发'),
      support: t('本店支持批发'),
    } as const;
  }, [t]);
}

function Wholesale({ prefix, singleMode }: { prefix?: Prefix; singleMode?: boolean }) {
  const label = useLabel();

  const {
    field: { value, onChange },
  } = useSmartField<FV['value']>(getPrefixName('value', prefix));

  const getHideStyle = (type: FV['value']) =>
    singleMode && value !== type ? { display: 'none' } : undefined;

  return (
    <div>
      {Object.keys(label).map((key) => {
        return (
          <div key={key} className="mb-2 mt-[6px]" style={getHideStyle(key)}>
            <Radio
              className={singleMode ? hideRadioClassName : undefined}
              checked={value === key}
              onChange={({ target: { checked } }) => checked && onChange(key)}
            >
              {label[key]}
            </Radio>
          </div>
        );
      })}
    </div>
  );
}

export function WholesaleBootGuide(props: AiModelState<FV>) {
  const label = useLabel();

  return (
    <ModalMode
      state={props}
      title={props.t('提供收据/发票')}
      tips={props.t(
        '我还需要了解一些您的「店铺服务」您的店铺是否提供收据/发票?以下是一些常见的选项供您选择和调整',
      )}
      form={<Wholesale />}
      getFirstInitialValues={useCallback(({ stores }): { values: FV[] } => {
        return {
          values: [
            { value: 'notS', storeScopes: stores2storeScopes(stores) },
            { value: 'invoice', storeScopes: [] },
            { value: 'invoiceAndReceipt', storeScopes: [] },
            { value: 'none', storeScopes: [] },
          ],
        };
      }, [])}
      updateApi={updateWholesale}
      getFirstFormItem={({ value }, _, storeSelect) => {
        return (
          <div>
            <section>
              {label[value]}
              {storeSelect}
            </section>
          </div>
        );
      }}
      getFirstFormStoreSelectKey={({ value }) => value}
    />
  );
}

export default Wholesale;
